// extracted by mini-css-extract-plugin
export default {"fieldheader":"fieldheader_b0ef145a22142d268210","icon":"icon_ac89b89af9f3bd587567","name":"name_b4e5f05b54e89ecd52c9","badge":"badge_e0c07039abf3df27e529"};